var exports = {
  "Pf": "xfd349460--50c627--label",
  "ff": "xfd349460--50c627--pros",
  "qu": "xfd349460--50c627--cons",
};

module.exports = exports;
